const SET_IS_DEMO = 'SET_IS_DEMO';
const SET_IS_GREET = 'SET_IS_GREET';
const SET_IS_SWITCHING = 'SET_IS_SWITCHING';
const PATCH = 'PATCH';

export { SET_IS_DEMO, SET_IS_GREET, SET_IS_SWITCHING, PATCH };
